import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

// Get all euro/ron rates with pagination
export const getEuroRonRates = async (token, options = {}) => {
  log("welcome in getEuroRonRates")

  if (!token || token === "") {
    return { error: true, message: "No token provided", rates: [] }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/get_euro_ron_rates_api'
    const params = {}
    if (options.page) params.page = options.page
    if (options.per_page) params.per_page = options.per_page
    if (options.include_terminated) params.include_terminated = 'true'

    const result = await axios.get(url, { headers, params })
    log("result.data from getEuroRonRates")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in getEuroRonRates")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching rates", rates: [] }
  }
}

// Save (create) a new euro/ron rate
export const saveEuroRonRate = async (token, rateData) => {
  log("welcome in saveEuroRonRate")
  log(rateData)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/save_euro_ron_rate_api'

    const result = await axios.post(url, rateData, { headers })
    log("result.data from saveEuroRonRate")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in saveEuroRonRate")
    log(err)
    error.value = err.message
    return { error: true, message: "Error saving rate" }
  }
}

// Get current (most recent) euro/ron rate
export const getCurrentEuroRonRate = async (token) => {
  log("welcome in getCurrentEuroRonRate")

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/get_current_euro_ron_rate_api'

    const result = await axios.get(url, { headers })
    log("result.data from getCurrentEuroRonRate")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in getCurrentEuroRonRate")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching current rate" }
  }
}

const useEuroRonRateAPI = () => {
  return { error, getEuroRonRates, saveEuroRonRate, getCurrentEuroRonRate }
}

export default useEuroRonRateAPI
